
const radioQuestionTypeList=[1,12,13,27,32,34,37,38,39,40]

export function changeOptionListList(list,quesId,root){
    let showRadio=false
    let shoMul=false
    const obj=list.find(val=>val.id==quesId)
    if(!obj || obj.question_type==7){
      return {showRadio:showRadio,shoMul:shoMul,list:[],questionType:obj.question_type}
    }
    if(root=="range"){
      showRadio=true
      shoMul=false
    }else if(radioQuestionTypeList.includes(obj.question_type)){
      showRadio=true
      shoMul=false
    }else if(obj.question_type==2 ){
      showRadio=false
      shoMul=true
    }
    const result={showRadio:showRadio,shoMul:shoMul,list:obj.issue.items,questionType:obj.question_type}
    return result
  }
  